var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.19 2H7.82C4.17 2 2 4.17 2 7.81V16.18C2 19.82 4.17 21.99 7.81 21.99H16.18C19.82 21.99 21.99 19.82 21.99 16.18V7.81C22 4.17 19.83 2 16.19 2Z",
    fill: "#565D73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4695 15.04C11.5395 15.11 11.6195 15.16 11.7095 15.2C11.7995 15.24 11.8995 15.26 11.9995 15.26C12.0995 15.26 12.1895 15.24 12.2895 15.2C12.3795 15.16 12.4595 15.11 12.5295 15.04L15.5295 12.04C15.8195 11.75 15.8195 11.27 15.5295 10.98C15.2395 10.69 14.7595 10.69 14.4695 10.98L12.7495 12.7V6.51001C12.7495 6.10001 12.4095 5.76001 11.9995 5.76001C11.5895 5.76001 11.2495 6.10001 11.2495 6.51001V12.7L9.52945 10.98C9.23945 10.69 8.75945 10.69 8.46945 10.98C8.17945 11.27 8.17945 11.75 8.46945 12.04L11.4695 15.04Z",
    fill: "#565D73"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7097 16.28C18.5797 15.89 18.1597 15.68 17.7597 15.81C14.0397 17.05 9.9497 17.05 6.2297 15.81C5.8397 15.68 5.40969 15.89 5.27969 16.28C5.14969 16.67 5.35969 17.1 5.74969 17.23C7.75969 17.9 9.86969 18.24 11.9897 18.24C14.1097 18.24 16.2197 17.9 18.2297 17.23C18.6297 17.09 18.8397 16.67 18.7097 16.28Z",
    fill: "#565D73"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload2);
export default __webpack_public_path__ + "static/media/download-2.f7ffe199a509eadb9f415ea5a30d61cd.svg";
export { ForwardRef as ReactComponent };